import * as React from "react";
import Box from "@mui/material/Box";
import Tabs, { tabsClasses } from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import ClearIcon from "@mui/icons-material/Clear";
import Tooltip from "@mui/material/Tooltip";

export default function tickerCategoryTabs({
  tickerCategoryList,
  selectedTickerCategory,
  handleChangeCategory,
}) {
  return (
    <Box
      sx={{
        flexGrow: 1,
        // maxWidth: { xs: 320, sm: 600 },
        bgcolor: "#333",
        color: "#fff",
      }}
    >
      <Tabs
        value={selectedTickerCategory}
        onChange={handleChangeCategory}
        variant="scrollable"
        scrollButtons
        aria-label="transparent background tabs"
        sx={{
          backgroundColor: "rgba(0, 0, 0, 0.6)", // Transparent black background
          boxShadow: "none", // Remove box shadow
          borderRadius: "10px", // Optional for rounded corners
          [`& .${tabsClasses.scrollButtons}`]: {
            "&.Mui-disabled": { opacity: 0.3 },
          },
          backdropFilter: "blur(10px)", // Optional for blur effect
        }}
      >
        {tickerCategoryList?.map((tickerCategory, index) => (
          <Tab
            label={tickerCategory}
            value={tickerCategory}
            sx={{
              color: "#fff", // White text color
              textTransform: "none", // Disable uppercase if preferred
              opacity: 0.7, // Make tabs a bit transparent by default
              "&.Mui-selected": {
                opacity: 1, // Full opacity when selected
                color: "orange", // Optional: Change text color when selected
              },
              "&:hover": {
                opacity: 1, // Increase opacity on hover
                color: "orange", // Change hover color (e.g., bright yellow)
                cursor: "pointer", // Show pointer cursor on hover
              },
            }}
            key={`${tickerCategory}-${index}`}
          />
        ))}
      </Tabs>
    </Box>
  );
}
